import * as React from 'react'
import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import SelectieButtonEnum from 'shared/components/SelectieButtonEnum'
import { Loader } from 'shared/components/Loader'
import { IApplicationState } from 'redux/store/store'
import { vestigingen, VestigingEnum, exceloptions } from 'shared/models/Enum'
import { ExportToCsv } from 'export-to-csv-fix-source-map'
import {
  IGetDataResponseAction,
  getDataActionCreator,
  clearDataActionCreator,
  IClearDataResponseAction,
  setWarehouseActionCreator,
  ISetWarehouseAction,
} from 'redux/store/actions/glnLocatiesPerVestigingAction'
import { ILocatieGlnModel } from 'shared/models/ILocatieGlnModel'
import { useState } from 'react'
import 'react-day-picker/lib/style.css'
import 'moment/locale/nl'
import { Redirect } from 'react-router'

interface IProps {
  requestData: (selectie: VestigingEnum) => Promise<IGetDataResponseAction>
  clearData: (message: string) => Promise<IClearDataResponseAction>
  setWarehouse: (warehouse: VestigingEnum) => Promise<ISetWarehouseAction>
  vestiging: VestigingEnum
  locaties: ILocatieGlnModel[]
  schermloading: boolean
  foutmelding: string
}

const GlnLocatiesPerVestigingLijst: React.FunctionComponent<IProps> = ({
  requestData,
  clearData,
  setWarehouse,
  vestiging,
  locaties,
  schermloading,
  foutmelding,
}) => {
  const setVestiging = x => {
    setWarehouse(x)
    clearData(null)
  }

  const [activeSort, setActiveSort] = useState('locatieGlnCode')

  const sortedLocations = (): ILocatieGlnModel[] => {
    if (!locaties) {
      return []
    } else {
      const types = {
        locatieGlnCode: 'locatieGlnCode',
        locatieGlnNaam: 'locatieGlnNaam',
        locatieGlnOmschrijving: 'locatieGlnOmschrijving',
      }
      const sortProperty = types[activeSort]
      console.log(`Sorteren op ${sortProperty}`)
      return locaties.sort((a, b) =>
        a[sortProperty] > b[sortProperty] ? 1 : -1
      )
    }
  }

  const zoekLocaties = () => {
    console.log('zoek locaties request')
    if (vestiging !== undefined && vestiging > 0) {
      requestData(vestiging)
    } else {
      clearData('Kies eerst een (geldige) vestiging!')
    }
  }

  const exportToCsv = () => {
    const csvExporter = new ExportToCsv(exceloptions)
    csvExporter.generateCsv(
      locaties.map(x => {
        return {
          LocatieGln: x.locatieGlnCode,
          LocatieNaam: x.locatieGlnNaam,
          LocatieOmschrijving: x.locatieGlnOmschrijving,
        }
      })
    )
  }

  const renderRows = (data: ILocatieGlnModel[]) => {
    return data.map(x => {
      return (
        <tr key={x.locatieGlnId}>
          <td>{x.locatieGlnCode}</td>
          <td className='mw-200 overflow-hidden' title={x.locatieGlnNaam}>
            {x.locatieGlnNaam}
          </td>
          <td
            className='mw-200 overflow-hidden'
            title={x.locatieGlnOmschrijving}
          >
            {x.locatieGlnOmschrijving}
          </td>
        </tr>
      )
    })
  }

  return (
    <div>
      {vestiging === 0 && <Redirect to='/home' />}
      <h2>GLN-Locaties per Vestiging</h2>

      <div>
        {schermloading && (
          <div>
            <Loader show={true} />
          </div>
        )}
        <table className='selectie'>
          <thead>
            <tr>
              <th className='selectie-label'>Vestiging:</th>
              <th className='selectie-label'></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <SelectieButtonEnum
                  type={VestigingEnum}
                  options={vestigingen}
                  selected={vestiging}
                  onChange={e => setVestiging(e.target.value)}
                />{' '}
              </td>
              <td>
                <div className='row no-gutters'>
                  <div className='col'></div>
                  <div className='col-auto'>
                    <button className='btn btn-primary' onClick={zoekLocaties}>
                      Zoek locaties
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {!!foutmelding && (
        <div className='alert alert-danger maxedbox'>{foutmelding}</div>
      )}
      {Array.isArray(locaties) && locaties.length > 0 && (
        <div>
          <table className='selectie'>
            <thead>
              <tr>
                <th colSpan={3} className='selectie-label'>
                  <div className='row'>
                    <div className='col-auto'>Locaties</div>
                    <div className='col-auto'>
                      <button className='btn btn-info' onClick={exportToCsv}>
                        Excel
                      </button>
                    </div>
                    <div className='col'></div>
                  </div>
                </th>
              </tr>
              <tr>
                <th colSpan={3}>
                  <hr />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className='tablesubheader'>
                <td>
                  <button
                    className='sortheader'
                    onClick={() => setActiveSort('locatieGlnCode')}
                  >
                    {' '}
                    Locatie Gln{' '}
                  </button>
                </td>
                <td>
                  <button
                    className='sortheader'
                    onClick={() => setActiveSort('locatieGlnNaam')}
                  >
                    Locatie Naam
                  </button>
                </td>
                <td>
                  <button
                    className='sortheader'
                    onClick={() => setActiveSort('locatieGlnOmschrijving')}
                  >
                    Locatie Omschrijving
                  </button>
                </td>
              </tr>
              {renderRows(sortedLocations())}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

const mapStateToProps = (store: IApplicationState) => {
  return {
    schermloading: store.glnLocatiesPerVestigingState.loading,
    vestiging: store.glnLocatiesPerVestigingState.vestiging,
    locaties: store.glnLocatiesPerVestigingState.locaties,
    foutmelding: store.glnLocatiesPerVestigingState.foutmelding,
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    requestData: (selectie: VestigingEnum) =>
      dispatch(getDataActionCreator(selectie)),
    clearData: (message: string) => dispatch(clearDataActionCreator(message)),
    setWarehouse: (warehouse: VestigingEnum) =>
      dispatch(setWarehouseActionCreator(warehouse)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GlnLocatiesPerVestigingLijst)
